
import { IngredientGroups, Ingredients, Ingredient, Menu, MenuId, UnitGrams } from '@/entity/entity'
import { Route } from '@/entity/route'
import router from '@/router'
import { StorageAccess } from '@/scripts/storage-access'
import { generateId } from '@/scripts/util'
import AddIngredient from '@/component/AddIngredient.vue'
import EditIngredient from '@/component/EditIngredient.vue'
import SelectOrigin from '@/component/SelectOrigin.vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'MenuModify',
  components: {
    AddIngredient, EditIngredient, SelectOrigin
  },
  props: {
    ingredients: {
      type: Object as () => Ingredients,
      required: true
    },
    ingredientGroups: {
      type: Object as () => IngredientGroups,
      required: true
    },
    unitGrams: {
      type: Object as () => UnitGrams,
      required: true
    }
  },
  data: function () : {
    menu: Menu,
    cancelLink: string,
    process: 'INITIAL' | 'ADD_INGREDIENT' | 'EDIT_INGREDIENT',
    currentEditId: string,
    originSelect: {id: string, origin: string}[],
    focusNoSelect: boolean,
    } {
    return {
      menu: {
        id: generateId() as MenuId,
        name: '',
        ingredients: []
      },
      cancelLink: this.$route.params.menuId ? Route.MenuList.path : Route.Search.path,
      process: 'INITIAL',
      currentEditId: '',
      originSelect: [],
      focusNoSelect: false
    }
  },
  computed: {
    addedFoodIds: function () : string[] {
      return this.menu.ingredients.map(ingredient => ingredient.id)
    },
    currentEditIndex: function () : number {
      if (this.currentEditId === '') return -1
      let index = -1
      for (let i = 0; i < this.menu.ingredients.length; i++) {
        if (this.menu.ingredients[i].id === this.currentEditId) {
          index = i
          break
        }
      }
      return index
    }
  },
  created: function () {
    if (!this.$route.params.menuId) return
    const menus = StorageAccess.getMenus()
    const search = menus.filter((menu) => menu.id === this.$route.params.menuId)
    if (search.length > 0) {
      this.menu = Object.assign({}, search[0])
      this.originSelect = this.menu.ingredients.map(x => ({
        id: x.id, origin: x.origin === '日本' ? '国産' : x.origin
      }))
    }
  },
  methods: {
    saveMenu: function (e: MouseEvent) {
      e.preventDefault()
      if (this.menu.name === '') {
        alert('料理名を入力してください。')
        return
      }
      if (this.menu.ingredients.length === 0) {
        alert('材料を追加してください。')
        return
      }
      const menus = StorageAccess.getMenus()
      let index = -1
      this.menu.ingredients = this.menu.ingredients.map((x, i) => ({ ...x, origin: this.originSelect[i].origin }))
      for (let i = 0; i < menus.length; i++) {
        if (menus[i].id === this.menu.id) {
          index = i
          break
        }
      }
      if (index === -1) {
        menus.push(this.menu)
      } else {
        menus[index] = Object.assign({}, this.menu)
      }
      StorageAccess.setMenus(menus)
      router.push(Route.MenuList.path)
    },
    showAddIngredient: function (e: MouseEvent) {
      e.preventDefault()
      this.process = 'ADD_INGREDIENT'
    },
    closeAddIngredient: function () {
      this.process = 'INITIAL'
    },
    addNewIngredient: function (ingredient: Ingredient) {
      this.menu.ingredients.push(ingredient)
      this.originSelect.push({
        id: ingredient.id,
        origin: ingredient.origin === '日本' ? '国産' : ingredient.origin
      })
      this.process = 'INITIAL'
    },
    deleteIngredient: function (index: number) {
      const cf = confirm('材料を削除します。よろしいですか？')
      if (!cf) return
      this.menu.ingredients.splice(index, 1)
      this.originSelect.splice(index, 1)
    },
    showEditIngredient: function (id: string) {
      if (!this.ingredients[id]) return
      this.currentEditId = id
      this.process = 'EDIT_INGREDIENT'
    },
    closeEditIngredient: function () {
      this.currentEditId = ''
      this.process = 'INITIAL'
    },
    saveIngredient: function (ingredient: Ingredient) {
      if (!this.menu.ingredients[this.currentEditIndex]) return
      this.menu.ingredients[this.currentEditIndex] = Object.assign(this.menu.ingredients[this.currentEditIndex], ingredient)
      this.originSelect = this.originSelect.map(x => x.id === this.menu.ingredients[this.currentEditIndex].id ? ({ id: x.id, origin: ingredient.origin }) : x)
      this.currentEditId = ''
      this.process = 'INITIAL'
    }
  }
})
